/**
 * Provides branding data from URL
 * using either 'branding' query string
 * or sub domain
 */

define(['query-string'], (queryString)=> {
    return {
        BRANDING: queryString.parse(window.location.search).channel // e.g. XXX?channel=custom gives "custom"
    };
});


// WEBPACK FOOTER //
// ../common/js/src/edge/platform/branding/BrandingData.js